import axios from 'axios';

const Aleatoria = async () => {
    try {
        const response = await axios.get('https://apem.riderup.uk/api/aleatoria/3', {
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao buscar bares:', error);
        return [];
    }
};

export default Aleatoria;
